import { TFunction } from 'i18next';

export function getRawDuration(rawDurationDisplay: string | undefined, t: TFunction): string | null {
  if (!rawDurationDisplay) return null;

  const durationNum = parseFloat(rawDurationDisplay);
  if (isNaN(durationNum)) return null;

  const isHours = rawDurationDisplay.toLowerCase().includes('hour');
  const key = `catalog.item.durationUnit${isHours ? 'Hour' : 'Minute'}`;

  return t(key, { count: durationNum });
}

export function getDuration(duration: string | undefined, t: TFunction): string | null {
  if (!duration) return null;

  const match = duration.toLowerCase().match(/(\d+(?:\.\d+)?)\s*(month|months|week|weeks|hour|hours)/);
  if (!match) return null;

  const count = parseFloat(match[1]);
  if (Number.isNaN(count)) return null;

  const unitStr = match[2];
  let unit: 'Month' | 'Week' | 'Hour';
  if (unitStr.startsWith('month')) {
    unit = 'Month';
  } else if (unitStr.startsWith('week')) {
    unit = 'Week';
  } else {
    unit = 'Hour';
  }

  return t(`catalog.item.durationUnit${unit}`, { count });
}
